"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = {
    BUY_TICKET: 'BUY_TICKET',
    VIEW_ITEM: 'VIEW_ITEM',
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-events/src/events.ts